export const FEATURE_FLAGS = {
  supportServiceTopics: true,
};
